<template>
  <footer class="footer" id="contact">
    <div class="footer-content">
      <div class="contact-section">
        <h3 class="section-title">联系我们</h3>
        <div class="contact-info">
          <div class="contact-item ultra-compact">
            <i class="fas fa-map-marker-alt contact-icon"></i>
            <div class="contact-details">
              <span class="label">地址：</span>
              <span class="value">浙江省宁波市鄞州区天银路55号俊鸿嘉瑞大厦2楼</span>
            </div>
          </div>

          <div class="contact-row compact-row">
            <div class="contact-item ultra-compact">
              <i class="fas fa-envelope contact-icon"></i>
              <div class="contact-details">
                <span class="label">邮编：</span>
                <span class="value">315100</span>
              </div>
            </div>

            <div class="contact-item ultra-compact">
              <i class="fas fa-phone contact-icon"></i>
              <div class="contact-details">
                <span class="label">电话：</span>
                <span class="value">400-963-2166</span>
              </div>
            </div>
          </div>

          <div class="contact-row compact-row">
            <div class="contact-item ultra-compact">
              <i class="fas fa-envelope-open contact-icon"></i>
              <div class="contact-details">
                <span class="label">邮箱：</span>
                <span class="value">info@taifeng1931.com</span>
              </div>
            </div>

            <div class="contact-item ultra-compact">
              <i class="fas fa-globe contact-icon"></i>
              <div class="contact-details">
                <span class="label">网址：</span>
                <span class="value">www.taifeng1931.com</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="social-section">
        <h3 class="section-title">关注我们</h3>
        <div class="social-grid">
          <div class="social-card large">
            <div class="qrcode-placeholder large">
              <img :src="getImageUrl('douyin.jpg')" alt="官方抖音店" class="qrcode-image">
            </div>
            <div class="social-name">官方抖音店</div>
          </div>

          <div class="social-card large">
            <div class="qrcode-placeholder large">
              <img :src="getImageUrl('tianmao.png')" alt="天猫旗舰店" class="qrcode-image">
            </div>
            <div class="social-name">天猫旗舰店</div>
          </div>

          <div class="social-card large">
            <div class="qrcode-placeholder large">
              <img :src="getImageUrl('xiaohongshu.jpg')" alt="官方小红书" class="qrcode-image">
            </div>
            <div class="social-name">官方小红书</div>
          </div>

          <div class="social-card large">
            <div class="qrcode-placeholder large">
              <img :src="getImageUrl('gongzhonghao.jpg')" alt="微信公众号" class="qrcode-image">
            </div>
            <div class="social-name">微信公众号</div>
          </div>

          <div class="social-card large">
            <div class="qrcode-placeholder large">
              <img :src="getImageUrl('kefu.jpg')" alt="微信客服号" class="qrcode-image">
            </div>
            <div class="social-name">微信客服号</div>
          </div>
        </div>
      </div>
    </div>

    <div class="copyright ultra-compact">
      <p class="copyright-text" @click="openLink">
        浙江丰沃国际贸易有限公司 版权所有 | 浙ICP备2021018069号-1
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  methods: {
    getImageUrl(imageName) {
      return require(`@/assets/footer/${imageName}`);
    },

    openLink() {
      window.open("https://beian.miit.gov.cn/#/Integrated/index");
    }
  }
};
</script>

<style scoped>
.footer {
  background: #e3e7eb;
  color: #333;
  padding: 25px 30px 10px;
  position: relative;
  border-top: 1px solid rgba(154, 27, 30, 0.1);
}

.footer::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: linear-gradient(to right, #9A1B1E, #B22222);
}

.footer-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 50px;
  margin-bottom: 15px;
}

.section-title {
  font-size: 1.1rem;
  margin-bottom: 15px;
  color: #222;
  position: relative;
  padding-bottom: 6px;
  font-weight: 600;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 30px;
  height: 2px;
  background-color: #9A1B1E;
  border-radius: 1px;
}

.contact-info {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.contact-row.compact-row {
  display: flex;
  gap: 15px;
}

.contact-item.ultra-compact {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  flex: 1;
  padding: 6px 0;
  transition: all 0.2s;
}

.contact-item.ultra-compact:hover {
  transform: translateX(2px);
}

.contact-icon {
  color: #9A1B1E;
  font-size: 0.9rem;
  width: 28px;
  height: 28px;
  background-color: rgba(154, 27, 30, 0.08);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.2s;
}

.contact-item:hover .contact-icon {
  background-color: #9A1B1E;
  color: white;
  transform: scale(1.05);
}

.contact-details {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
  line-height: 1.3;
}

.label {
  font-weight: 600;
  color: #666;
  font-size: 0.8rem;
  white-space: nowrap;
}

.value {
  color: #444;
  font-size: 0.85rem;
  line-height: 1.4;
}

.social-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 15px;
}

.social-card.large {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid rgba(154, 27, 30, 0.08);
  background: white;
}

.social-card.large:hover {
  transform: translateY(-3px);
  border-color: rgba(154, 27, 30, 0.2);
  box-shadow: 0 4px 12px rgba(154, 27, 30, 0.1);
}

.qrcode-placeholder.large {
  width: 90px;
  height: 90px;
  background: white;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(154, 27, 30, 0.1);
}

.qrcode-placeholder.large::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, transparent, rgba(154, 27, 30, 0.05), transparent);
  animation: shine 2s infinite;
}

.qrcode-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 6px;
}

.social-name {
  font-size: 0.8rem;
  color: #333;
  font-weight: 600;
  text-align: center;
  line-height: 1.2;
  padding: 0 2px;
}

.social-card.large:hover .social-name {
  color: #9A1B1E;
}

.copyright.ultra-compact {
  text-align: center;
  padding-top: 12px;
  padding-bottom: 5px;
  border-top: 1px solid rgba(154, 27, 30, 0.1);
  color: #666;
  font-size: 0.75rem;
  line-height: 1.2;
}

.copyright.ultra-compact p {
  margin: 0;
}

.copyright-text {
  color: #666;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-block;
  padding: 2px 5px;
  border-radius: 3px;
}

.copyright-text:hover {
  color: #9A1B1E;
  transform: scale(1.05);
  background-color: rgba(154, 27, 30, 0.05);
}

@media (max-width: 992px) {
  .footer {
    padding: 20px 20px 8px;
  }

  .footer-content {
    gap: 40px;
  }

  .social-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 15px;
  }

  .qrcode-placeholder.large {
    width: 85px;
    height: 85px;
  }
}

@media (max-width: 768px) {
  .footer-content {
    grid-template-columns: 1fr;
    gap: 35px;
  }

  .contact-row.compact-row {
    flex-direction: column;
    gap: 8px;
  }

  .social-grid {
    grid-template-columns: repeat(5, 1fr);
    gap: 12px;
  }

  .qrcode-placeholder.large {
    width: 75px;
    height: 75px;
  }
}

@media (max-width: 640px) {
  .footer {
    padding: 18px 15px 6px;
  }

  .section-title {
    font-size: 1rem;
    margin-bottom: 12px;
  }

  .social-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 15px;
  }

  .qrcode-placeholder.large {
    width: 70px;
    height: 70px;
  }

  .social-name {
    font-size: 0.75rem;
  }

  .copyright.ultra-compact {
    padding-top: 10px;
    font-size: 0.7rem;
  }

  .copyright-text:hover {
    transform: scale(1.03);
  }
}

@media (max-width: 480px) {
  .social-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
  }

  .qrcode-placeholder.large {
    width: 80px;
    height: 80px;
  }
}

@media (max-width: 360px) {
  .footer {
    padding: 15px 12px 5px;
  }

  .social-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }

  .qrcode-placeholder.large {
    width: 70px;
    height: 70px;
  }
}

@keyframes shine {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}
</style>